import { render, staticRenderFns } from "./PermitTypeSummary.vue?vue&type=template&id=7abbdbcf&scoped=true"
import script from "./PermitTypeSummary.vue?vue&type=script&lang=js"
export * from "./PermitTypeSummary.vue?vue&type=script&lang=js"
import style0 from "./PermitTypeSummary.vue?vue&type=style&index=0&id=7abbdbcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abbdbcf",
  null
  
)

export default component.exports